module.exports = __webpack_public_path__ + "assets/img/6.ec12be96.jpg";